export default {"gitHash":"d5a33ef40b4148d03818e9aa7bc8ffe608c887d0","gitHashShort":"d5a33ef","time":1650113970127,"platform":"linux","arch":"x64"};